export const PRIVILEGIOS = {
  Super: 1,
  PROFESSOR: 2,
  ALUNO: 3,
  GESTOR: 6,
  CONTEUDO: 5,
  SECRETARIA: 9,
  OPERADOR: 10,
  ADMIN: 11
}
